<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Mona Rabea is a phoniatrician with MSc of Phoniatrics (2017), M.B.B.Ch. (2008), Faculty of Medicine, Mansoura University, Egypt. She is interested in academic writing on phoniatrics.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4b177e9a